import HeartMountainData from "../../../../src/components/heart-mountain-data.js";
import * as React from 'react';
export default {
  HeartMountainData,
  React
};